import { AttributeModel } from "src/models";
import { staticDefaultAttributesNames } from "src/constants";

export const checkIfAttributeIsStatic = (attribute: AttributeModel) => {
  return staticDefaultAttributesNames.includes(attribute.name);
};
